import type { ResourceOption } from '@krp/ui-kit'

/** Источник из списка Cashiers: вид (`kind`) приходит с сервера, метку вида даёт приложение. */
export interface SourceItem {
  id: string
  name: string
  kind?: string
}

/** Состояние загрузки списка источников для поля выбора: пустой список при загрузке — не «источников нет». */
export interface SourcesLoad {
  loading: boolean
  error: string | null
  retry: () => void
}

/**
 * Как показывать вид источника: метка, цвет и общий порядок источников (решение владельца 03.11.2026). Видов пакет не знает —
 * их даёт приложение из реестра форм подключения.
 */
export interface SourceKinds {
  markOf: (kind: string) => string
  toneOf: (kind: string) => string | null
  compareSources: (left: { kind: string; displayName: string; id?: string }, right: { kind: string; displayName: string; id?: string }) => number
}

const orderKey = (source: SourceItem) => ({ kind: source.kind ?? '', displayName: source.name, id: source.id })

/** Пункты поля `ResourceSelectField` в общем порядке источников: имя, метка и цвет вида, когда вид известен. */
export function sourceOptions(sources: readonly SourceItem[], kinds: SourceKinds | undefined): ResourceOption[] {
  const ordered = kinds === undefined ? sources : [...sources].sort((left, right) => kinds.compareSources(orderKey(left), orderKey(right)))
  return ordered.map((source) => {
    const kind = source.kind === undefined || source.kind === '' || kinds === undefined ? null : source.kind
    const tone = kind === null ? null : kinds?.toneOf(kind) ?? null
    return {
      value: source.id,
      label: source.name,
      ...(kind === null ? {} : { mark: kinds?.markOf(kind) ?? kind }),
      ...(tone === null ? {} : { tone }),
    }
  })
}
